export enum BookingTabMenuEnum {
    None = 0,
    Bookings = 1,
    ScanAndRide = 2,
    Scheduled = 3,
    Twenty = 4,
    OneHundred = 5,
	FiveHundred = 6,
	Hailed = 7
}
